import { memo } from 'react';
import { Text, VStack } from '@chakra-ui/react';

import NextImage from 'shared/NextImage';
import InterText from 'shared/InterText';

const MentorCard = ({ name, role, text, icon, iconProps, textsContainerProps = null }) => (
  <VStack
    pos="relative"
    w={{ mobile: 'full', tablet: '570px', laptop: '630px' }}
    h="full"
    minH={{ mobile: '532px', tablet: '470px', laptop: '548px' }}
    align="start"
    bgColor="ourWhite"
    p={{ mobile: '24px', tablet: '32px', laptop: '48px' }}
    borderRadius={{ mobile: '24px', tablet: '32px', laptop: '48px' }}
    overflow="hidden"
  >
    <VStack
      w="full"
      maxW={{ tablet: '275px', laptop: '310px' }}
      h="full"
      align="start"
      justify={{ tablet: 'space-between' }}
      pos="relative"
      zIndex="2"
      {...textsContainerProps}
    >
      <VStack
        w="full"
        align="start"
        gap={{ mobile: '6px', tablet: '12px', laptop: '16px' }}
        pb={{ mobile: '16px', tablet: 'unset' }}
        borderBottom={{ mobile: '1.3px solid', tablet: 'none' }}
        borderBottomColor="rgba(21, 29, 40, 0.15)"
      >
        <Text
          as="h3"
          textStyle="h2"
          fontSize={{ mobile: '30px', tablet: '36px', laptop: '48px' }}
          color="greenMuted"
        >
          {name}
        </Text>

        <InterText
          textStyle="b3"
          fontSize={{ mobile: '15px', tablet: '16px', laptop: '18px' }}
          color="ourGrayThree"
        >
          {role}
        </InterText>
      </VStack>

      <VStack align="start" gap={{ mobile: '4px', tablet: '10px' }}>
        <InterText
          color="ourBlack"
          textStyle="b2"
          fontSize={{ mobile: '15px', tablet: '18px', laptop: '24px' }}
        >
          Тебе предстоит
        </InterText>

        <InterText
          textStyle="b3"
          fontSize={{ mobile: '15px', tablet: '16px', laptop: '18px' }}
          lineHeight={{ mobile: '120%', tablet: '140%' }}
          color={{ mobile: 'ourBlack', tablet: 'ourGrayThree' }}
        >
          {text}
        </InterText>
      </VStack>
    </VStack>

    <NextImage src={icon} alt={name} pos="absolute" zIndex="1" {...iconProps} />
  </VStack>
);

export default memo(MentorCard);
